module.exports = __webpack_public_path__ + "img/STAR_app_campus_VD.6e174850.png";